import { useEffect } from 'react';
import { useStoredState } from '@/hooks';
import { ApiRequestError } from '@/lib/api-client';
import { logger } from '@/lib/logger';
import type { Clinic } from '@/types/api';
import { settingsApi } from './api';

/**
 * The clinic's settings (working hours, calendar range…), kept on the device
 * so the calendar can lay itself out offline too.
 */
export function useClinicSettings(clinicId: string): Clinic | null {
  const [clinic, setClinic] = useStoredState<Clinic | null>(`dentlog.clinic.${clinicId}`, null);
  useEffect(() => {
    settingsApi
      .clinic()
      .then(setClinic)
      .catch((err) => {
        if (!(err instanceof ApiRequestError && err.isNetwork)) logger.warn('clinic failed', err);
      });
  }, [setClinic]);
  return clinic;
}
